const changeTrackingPeekedColumnsSelector = (state) => state.get('changeTrackingPeekedColumns');



export const peekedColumnsSelector = (state) => changeTrackingPeekedColumnsSelector(state).get('peekedColumns');
